// src/pages/Dashboard.js
import React, { useState, useEffect } from "react";
import api from "../api/axiosConfig";
import DashboardPieChart from "../components/dashboard/DashboardPieChart";

import { BarChart3, Users, RefreshCcw, PauseCircle } from "lucide-react";

export default function Dashboard() {
  const [dashboardData, setDashboardData] = useState({
    totalSubscriptions: 0,
    activeCustomers: 0,
    trialCustomers: 0,
    inactiveCustomers: 0,
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const response = await api.post("/user/customers/dashboard", {});
      
      if (response.data && response.data.data) {
        setDashboardData({
          totalSubscriptions: response.data.data.totalSubscriptions || 0,
          activeCustomers: response.data.data.activeCustomers || 0,
          trialCustomers: response.data.data.trialCustomers || 0,
          inactiveCustomers: response.data.data.inactiveCustomers || 0,
        });
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setLoading(false);
    }
  };

const StatCard = ({ icon: Icon, title, value, subtitle, isLoading }) => (
    <div
      className="bg-[#e8f5e9] rounded-xl shadow-lg p-6 text-black relative overflow-hidden border border-[#c8e6c9]"
    >
      <div className="absolute -top-8 -right-8 w-32 h-32 bg-[#c8e6c9]/30 rounded-full blur-2xl"></div>

      <div className="relative">
        <div className="flex items-center justify-between mb-4">
         <Icon size={36} className="text-green-700" />

          <div className="text-right">
            <p className="text-xs font-semibold text-black/70 uppercase tracking-wide">
              {title}
            </p>

            {isLoading ? (
              <div className="h-9 w-16 bg-[#c8e6c9]/40 rounded animate-pulse mt-1"></div>
            ) : (
              <h2 className="text-3xl font-bold mt-1 text-black">{value}</h2>
            )}
          </div>
        </div>

        {subtitle && (
          <p className="text-sm text-black/80 mt-2">{subtitle}</p>
        )}
      </div>
    </div>
  );

  return (
    <div className="space-y-8 bg-gray-50 dark:bg-slate-900 min-h-screen p-6 transition-colors">

      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold text-slate-900 dark:text-white">
          Dashboard
        </h1>

        <p className="text-slate-600 dark:text-slate-400 mt-2">
          Real-time metrics and insights
        </p>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">

<StatCard
  icon={BarChart3}
  title="Total Subscriptions"
  value={dashboardData.totalSubscriptions}
  isLoading={loading}
/>

<StatCard
  icon={Users}
  title="Active Customers"
  value={dashboardData.activeCustomers}
  isLoading={loading}
/>

<StatCard
  icon={Users}
  title="Trial Customers"
  value={dashboardData.trialCustomers}
  isLoading={loading}
/>

<StatCard
  icon={PauseCircle}
  title="Inactive Customers"
  value={dashboardData.inactiveCustomers}
  isLoading={loading}
/>
      </div>

    </div>
  );
}